import { render, staticRenderFns } from "./callback-add-or-update.vue?vue&type=template&id=4d8bf8a4&scoped=true&"
import script from "./callback-add-or-update.vue?vue&type=script&lang=js&"
export * from "./callback-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./callback-add-or-update.vue?vue&type=style&index=0&id=4d8bf8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8bf8a4",
  null
  
)

export default component.exports